export default {
	filterByKeys(object, allowed_keys) {
		Object.keys(object)
			.filter(key => !allowed_keys.includes(key))
			.forEach(key => delete object[key]);
	}
}

